<template lang="pug">
f7-page#application
  navbar-bridge-swift(title="無料体験レッスン申し込み" back @click="onClickBack")
  background-image
    application-form(
      ref="form"
      v-model="isValid"
    )
    .footer-box
      large-button(
        title="無料体験レッスンに申し込む"
        class="application-button"
        :disabled="!isValid"
        @click="onClickApply"
      )
      f7-link(class="flow-link" @click="didTapShowLessonFlow")
        svg-icon(icon="question")
        | 詳しいレッスン内容を見てみる
  popup-lesson-flow(
    :opened='opened',
    @close='opened = false'
  )
</template>

<style lang="scss" scoped>
#application {
  min-height: 700px;
}
.footer-box {
  position: absolute;
  bottom: 0px;
  min-height: 210px !important;
  @media (max-height: 630px) {
    min-height: 140px !important;
  }
  width: 100%;
  background: none;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  .agree-message {
    text-align: center;
    @extend %description;

    a {
      color: #fff;
      text-decoration: underline;
    }
  }
  .flow-link {
    @extend %narrow-button-text;
    margin: 8px 0;
    @media (max-height: 630px) {
      margin: 0;
    }

    .svg-icon {
      display: inline-flex;
      margin-right: 8px;
      width: 12px;
      height: 12px;
    }
  }
  .separator {
    height: 1px;
    margin: 0 24px;
    background: rgba(255, 255, 255, 0.4);
  }
  .login-button-box {
    text-align: center;
    margin: 8px 0;
    @media (max-height: 630px) {
      margin: 0;
    }

    p {
      @extend %body-text;
      margin: 0;

      a {
        @extend %login-link-text;
        margin-left: 32px;
      }
    }
  }
}
</style>

<script>
import { mapActions } from 'vuex'
import Navbar from '@/components/organisms/Navbar'
import ApplicationForm from '@/components/organisms/ApplicationForm'
import LargeButton from '@/components/atoms/LargeButton'
import PopupLessonFlow from '@/components/organisms/PopupLessonFlow'
import NavbarBridgeSwift from '@/components/organisms/NavbarBridgeSwift'

export default {
  components: {
    Navbar,
    ApplicationForm,
    LargeButton,
    PopupLessonFlow,
    NavbarBridgeSwift,
  },
  data() {
    return {
      isValid: false,
      isSubmitted: false,
      opened: false,
    }
  },
  methods: {
    ...mapActions('application', ['apply', 'initialize']),
    async onClickApply() {
      if (!this.isSubmitted) {
        this.isSubmitted = true

        try {
          await this.$refs['form'].submit()
        } finally {
          this.isSubmitted = false
        }

        this.apply(this.$refs['form']._data.name)

        this.$f7router.navigate({
          name: 'PublicApplicationDone',
        })
      }
    },
    didTapShowLessonFlow() {
      //this.postMessageToSwift('didTapShowLessonFlow')
      this.opened = true
    },
    onClickBack() {
      if (this.$f7router.history.length === 1) {
        this.postMessageToSwift('didTapBack')
      } else {
        this.$f7router.back()
      }
    },
  },
  mounted() {
    this.initialize()
  },
}
</script>
